export default __webpack_public_path__ + "static/media/user.93e1efb8.svg";